export function lockTime(kickoff: string | Date) {
  const k = typeof kickoff === "string" ? new Date(kickoff) : kickoff;
  return new Date(k.getTime() - 15 * 60 * 1000);
}

export function isLocked(kickoff: string | Date) {
  return Date.now() >= lockTime(kickoff).getTime();
}

export function isFinal(kickoff: string | Date) {
  const k = typeof kickoff === "string" ? new Date(kickoff) : kickoff;
  return Date.now() >= k.getTime() + 110 * 60 * 1000; // ~110 min after kickoff
}

export function countdownParts(target: Date) {
  let diff = Math.max(0, target.getTime() - Date.now());
  const d = Math.floor(diff / 86_400_000); diff -= d * 86_400_000;
  const h = Math.floor(diff / 3_600_000); diff -= h * 3_600_000;
  const m = Math.floor(diff / 60_000); diff -= m * 60_000;
  const s = Math.floor(diff / 1000);
  return { d, h, m, s, total: target.getTime() - Date.now() };
}

export function formatKickoff(iso: string) {
  const d = new Date(iso);
  return d.toLocaleString("de-DE", {
    weekday: "short", day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", timeZone: "Europe/Berlin",
  }) + " MESZ";
}
